export default "__VITE_ASSET__C_ZxDE9R__"